import { HubspotCompanyRoutes } from '@/repository/resources';
const { GetFields, GetCompany, CreateCompany, UpdateCompany, DeleteCompany } = HubspotCompanyRoutes;

// Export this module
export default {
	namespaced: true,
	actions: {
		async show({ }, { id }) {
			try {
				let res = await GetCompany({ company: id });
				return res.data
			}
			catch (error) {
				console.error('Hubspot company could not be shown.', error);
				throw error;
			}
		},

		async createOrUpdate({ }, { company }) {
			try {
				let res = {};
				res = company.id ? await UpdateCompany({ company }) : await CreateCompany({ company });
				return res;
			}
			catch (error) {
				console.error('Hubspot company could not be created/updated.', error);
				throw error;
			}
		},

		async delete({ }, { company }) {
			try {
				let res = await DeleteCompany({ company });
				if (res.status !== 204) {
					throw 'Problem occurred when deleting Hubspot company.';
				}
				return true;
			}
			catch (error) {
				console.error('Hubspot company could not be deleted.', error);
				throw error;
			}
		},

		async fields({ }, { }) {
			try {
				let res = await GetFields({});
				return res.data
			}
			catch (error) {
				console.error('Hubspot company fields could not be shown.', error);
				throw error;
			}
		}

	}
}